module.exports = __webpack_public_path__ + "img/4041aec.jpg";